export default "__VITE_PUBLIC_ASSET__c62ac894__"